// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/rpa-collision-hazard.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/rpa-collision-hazard/rpa-collision-hazard.js';
import g1 from '../lessons/aeronautics/rpa-collision-hazard/rpas-regulations.js';

mount([g0, g1]);
